const TEST_ID_EDIT_BUTTON = 'edit-address-btn';
const QUESTION_TEXT_TO_CONFIRM_ADDRESS = 'O endereço de entrega é esse mesmo?';
const CONFIRM_ADDRESS_BUTTON_VALUE = 'Sim';
const DENY_ADDRESS_BUTTON_VALUE = 'Não, quero mudar';
const BLOCKED_EDITION_QUESTION_TEXT_TO_CONFIRM_ADDRESS =
  'O endereço está correto?';
const BLOCKED_EDITION_CONFIRM_ADDRESS_BUTTON_VALUE = 'Sim';
const BLOCKED_EDITION_DENY_ADDRESS_BUTTON_VALUE = 'Não';
const PICKUP_INSTRUCTIONS_TEXT_VALUE =
  'Leve seu RG ou CNH e o código de rastreamento para retirar o pacote neste endereço:';

export {
  TEST_ID_EDIT_BUTTON,
  QUESTION_TEXT_TO_CONFIRM_ADDRESS,
  CONFIRM_ADDRESS_BUTTON_VALUE,
  DENY_ADDRESS_BUTTON_VALUE,
  BLOCKED_EDITION_QUESTION_TEXT_TO_CONFIRM_ADDRESS,
  BLOCKED_EDITION_CONFIRM_ADDRESS_BUTTON_VALUE,
  BLOCKED_EDITION_DENY_ADDRESS_BUTTON_VALUE,
  PICKUP_INSTRUCTIONS_TEXT_VALUE
};
